import React from 'react';
import Portal from 'react-portal';

import classnames from 'classnames';

import {setBackgroundScrollable} from '../../util/scroll';

import './styles';

class InnerModal extends React.Component {
  componentDidMount() {
    setBackgroundScrollable(false);
  }

  render() {
    return (
      <div className={classnames('Modal ui scrolling', this.props.size, this.props.className, 'modal transition visible active')} ref="modal">
        {(() => {
          if (this.props.header) {
            if (typeof this.props.header === 'string') {
              return (
                <div className="ui header">
                  {this.props.header}
                </div>
              );
            } else {
              return this.props.header;
            }
          }
        })()}
        {!this.props.unclosable && <i className="close icon" onClick={this.props.onClose} />}
        <div className={classnames({visibleOverflow: this.props.visibleOverflow}, 'content')}>
          {this.props.children}
        </div>
        {this.props.actions && (
          <div className="actions">
            {this.props.actions}
          </div>
        )}
      </div>
    );
  }

  componentWillUnmount() {
    setBackgroundScrollable(true);
  }
}

class Modal extends React.Component {
  close(event) {
    if (!this.props.open) {
      return;
    }
    if (this.props.onCloseClick) {
      this.props.onCloseClick(event);
    }
  }

  render() {
    let active = !!this.props.open;
    let inputModalStyle = this.props.style || {};
    let modalStyle = Object.assign({overflowY: 'auto'}, inputModalStyle);
    return (
      <Portal
          closeOnEsc={this.props.closeOnEsc}
          closeOnOutsideClick={this.props.closeOnOutsideClick}
          onClose={(this.props.open && this.props.onClose) || (n => n)}
          className={classnames('ui dimmer modals visible active page transition', this.props.dimmerClass)} isOpened={active} style={modalStyle}>
        <InnerModal {...this.props} onClose={this.close.bind(this)}>
          {this.props.children}
        </InnerModal>
      </Portal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./~/sp-components/components/Modal/index.jsx